import {graph2} from '../utils/shared'


export const agent_promos = async(agent_id, fields, token) => {
    let q = `{agent_promotional_codes(agent_id: ${agent_id}) {
		result {
            ${fields}
		}
		error {
			... on Unexpected_Error {
				message
			}
		}
	}}`

    let x = await graph2(q, token)
    return x
}

export const agent_promo = async(code_id, fields, token) => {
    let q = `{agent_promotional_code(code_id: ${code_id}) {
		result {
            ${fields}
		}
		error {
			... on Unexpected_Error {
				message
			}
		}
	}}`

    let x = await graph2(q, token)
    return x
}

export const agent_promo_add = async(agent_id, code, cookie_verification, expire, amount, discount_type, departure_from, departure_to, minimum_cost, number_of_uses, fields, token) => {

	let cv = null;
	if(cookie_verification != null){
		cv = '"' + cookie_verification + '"';
	}
    let q = `mutation {agent_promotional_code_add(agent_id: ${agent_id}, code: "${code}", cookie_verification: ${cv}, expire: "${expire}", amount: ${amount}, 
        discount_type: ${discount_type}, departure_from: "${departure_from}", departure_to: "${departure_to}", minimum_cost: ${minimum_cost}, number_of_uses: ${number_of_uses}) {
		result {
            ${fields}
		}
		error {
			... on Unexpected_Error {
				message
			}
		}
	}}`

    let x = await graph2(q, token)
    return x
}

export const agent_promo_update = async(agent_id, code_id, code, cookie_verification, expire, amount, discount_type, departure_from, departure_to, minimum_cost, number_of_uses, fields, token) => {
    let q = `mutation {agent_promotional_code_update(agent_id: ${agent_id}, code_id: ${code_id}, code: "${code}", cookie_verification: "${cookie_verification}", expire: "${expire}", amount: ${amount}, 
        discount_type: ${discount_type}, departure_from: "${departure_from}", departure_to: "${departure_to}", minimum_cost: ${minimum_cost}, number_of_uses: ${number_of_uses}) {
		result {
            ${fields}
		}
		error {
			... on Unexpected_Error {
				message
			}
		}
	}}`

    let x = await graph2(q, token)
    return x
}

export const agent_promo_remove = async(agent_id, code_id, fields, token) => {
    let q = `mutation {agent_promotional_code_remove(agent_id: ${agent_id}, code_id: ${code_id}) {
		result {
            ${fields}
		}
		error {
			... on Unexpected_Error {
				message
			}
		}
	}}`

    let x = await graph2(q, token)
    return x
}